import React, { useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { observer, useLocalStore } from 'mobx-react';
import { Row } from 'react-bootstrap';
import { withErrorBoundary } from 'react-error-boundary';
import FreeTierVCStore, { FreeTierVCContext } from './store';
import { storesContext } from '../../stores';
import { handleError } from '../../services/ErrorService';
import GenericViewError from '../../components/Error/GenericViewError';
import FreeTierVideoClassroomComponent from '../../components/VideoClassroom/FreeTier';

const FreeTierVideoClassroom = () => {
  const { routerStore } = useContext(storesContext);
  const vcStore = useLocalStore(() => new FreeTierVCStore());
  const { route } = routerStore;
  const courseCode = route.params.course.slice(0, -2);
  const pageTitle = vcStore.vc.header?.title;

  useEffect(() => {
    vcStore.getVCDetails(courseCode);
  }, []);

  useEffect(() => {
    vcStore.getVCDetails(courseCode);
  }, [route.params.course]);

  return (
    <>
      {pageTitle && <Helmet title={`${pageTitle} - Red Hat Learning`} />}
      <div className="container-grid-responsive">
        <Row>
          <FreeTierVCContext.Provider value={vcStore}>
            <FreeTierVideoClassroomComponent />
          </FreeTierVCContext.Provider>
        </Row>
      </div>
    </>
  );
};

export default withErrorBoundary(
  observer(FreeTierVideoClassroom),
  GenericViewError,
  handleError,
);
